var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{on:{"loadingFinished":function($event){return _vm.$emit('loadingFinished')},"showPreloader":function($event){return _vm.$emit('showPreloader')}}})}
var staticRenderFns = []

export { render, staticRenderFns }